import { auth } from './firebase';
import { doUnlogUser } from './db';

// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
   auth.createUserWithEmailAndPassword(email, password)



// Sign In
export const doSignInWithEmailAndPassword = async (email, password) => {
    let errorOutput = ''
    await auth.signInWithEmailAndPassword(email, password)
    .catch(error => {
        errorOutput = error.code
      });
      
      return errorOutput
}
// Sign out
export const doSignOut = async (id) => {
  
    if(id){
        await doUnlogUser(id) 
        auth.signOut()
    }
    else {
        
        console.log('auth.js: nicht mehr angemeldet')
    
    }

}
  // Password Reset
export const doPasswordReset = (email) =>
    auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = (password) =>
    auth.currentUser.updatePassword(password);



// WEBPACK FOOTER //
// ./src/firebase/auth.js